import React, { Component } from 'react';
import DocumentCard from 'Components/cards/DocumentCard';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './ProductivityReport.scss';
import { setSearchOpenFlag } from 'Actions/drawerAction';

export class ProductivityReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportData: [
                { reportId: "1", pageListId: "dail_prd_rpt", reportName: "Detail Productivity Report" },
                { reportId: "2", pageListId: "dail_sury_prd_rpt", reportName: "Daily Summary Productivity Report" },
                { reportId: "3", pageListId: "hrly_prd_rpt", reportName: "Hourly Summary Productivity Report" },
                { reportId: "4", pageListId: "mnthly_prd_rpt", reportName: "Monthly Summary Productivity Report" }
            ],
            isLoading: false,
        };
    }

    viewReportPage = (report) => {
        if (report.pageListId == "dail_prd_rpt") {
            this.props.history.push({ pathname: "/reports/detailedreport", state: { reportName: report.reportName, pageId: report.pageListId } })
        } else if (report.pageListId == "dail_sury_prd_rpt"){
            this.props.history.push({ pathname: "/reports/dailysummary", state: { reportName: report.reportName, pageId: report.pageListId } })
        } else if (report.pageListId == "hrly_prd_rpt"){
            this.props.history.push({ pathname: "/reports/hourlysummary", state: { reportName: report.reportName, pageId: report.pageListId } })
        } else if (report.pageListId == "mnthly_prd_rpt"){
            this.props.history.push({ pathname: "/reports/monthlysummary", state: { reportName: report.reportName, pageId: report.pageListId } })
        }

    }

    getDocumentCard = (reports) => {
        return (
            <div className="card-list">
                {
                    reports.map((report) => {
                        return (
                            <DocumentCard
                                key={report.reportId}
                                title={report.reportName}
                                primaryAction={() => {
                                    this.viewReportPage(report);
                                }}
                                primaryActionText='View Report'
                                secondaryOptions={[]}
                                document={report}
                                isReportIcon={true}
                            >
                            </DocumentCard>
                        );
                    })
                }
            </div>
        );
    }

    get reportCards() {
        return (
            <section className="reports-container">
                <div className={this.props.isSearchActive ? 'main-content--header secondary-header' : "main-content--header "} style={{ zIndex: 2 }}>
                    <h1>Productivity Reports</h1>
                </div>
                <span className="operation-reports" style={{paddingTop: this.props.isSearchActive ? "20px" : "84px"}}>
                    {
                        this.getDocumentCard(this.state.reportData)
                    }

                </span>
            </section >
        );
    }

    render() {
        window.document.title = 'Productivity Reports';
        return (
            <section className="reports-container">
                {
                    (!this.state.isLoading) ? (
                        this.reportCards) :
                        (
                            this.state.isLoading && (
                                <div className="ball-sync-loader loader" style={{ height: 200, backgroundColor: 'white' }}>
                                    <BVLoader20 />
                                </div>
                            )
                        )
                }
            </section>
        );
    }
}

ProductivityReport.propTypes = {

};

ProductivityReport.defaultProps = {

};
const mapStateToProps = (state) => ({
    isSearchActive: state.appSearch.isSearchActive,
});

const mapDispatchToProps = (dispatch) => {
    return {
        setSearchOpenFlag: (isSearchActive) => {
            dispatch(setSearchOpenFlag(isSearchActive));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductivityReport));
